import styled from 'styled-components';
import { Fonts } from '../../config/theme';

const Wrapper = styled.div`
  width: 100%;
  .select {
    width: 100%;
    position: relative;
    font-family: ${Fonts.secondary};
  }
  .icon {
    margin-left: 10px;
  }

  .dropdown {
    position: absolute;
    left: 0;
    right: 0;
    padding: 4px;
    display: flex;

    align-items: center;
    flex-direction: column;
    background: var(--color-light);
    border: 1px solid rgba(204, 212, 214, 0.5);
    border-radius: 5px;
    box-shadow: 0px 8px 12px rgba(0, 39, 51, 0.12);
    z-index: 99999999999;
    font-family: ${Fonts.secondary};
    overflow-y: scroll;
    max-height: 200px;
    overflow-x: hidden;
  }

  button {
    width: 100%;
    min-width: 100px;
    border: none;
    background: var(--color-light);
    color: rgba(17, 12, 12, 0.747);
    font-size: 13px;
    cursor: pointer;
    padding: 12px 0;
    border-radius: 5px;
    font-family: ${Fonts.secondary};
  }
  button:hover {
    background: #f2f4f5;
  }
  .value-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13x;

    background: var(--color-light);
    padding: 15px;
    border: 1px solid #504f4f3d;
    border-radius: 5px;
    cursor: pointer;
    user-select: none;
    font-family: ${Fonts.secondary};
  }
  .value-container:hover {
    background: transparent;
  }
  .selected {
    color: var(--app-color-dark);
  }
`;

export default Wrapper;
